
import { defineComponent } from "vue";

import EnterButton from "./EnterButton.vue";
import CancelButton from "./CancelButton.vue";
export default defineComponent({
  name: "Alert",
  components: {
    EnterButton,
    CancelButton,
  },
  props: {
    ngText: {
      type: String,
      default: "",
    },
    onClickNg: {
      type: Function,
      default: null,
    },
    okText: {
      type: String,
      default: "",
    },
    onClickOk: {
      type: Function,
      default: null,
    },
  },
});
